/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * ```
 */
export const SvuCrossNames = {
  JIHOCESKY_KRAJ: 'JIHOCESKY_KRAJ',
  JIHOMORAVSKY_KRAJ: 'JIHOMORAVSKY_KRAJ',
  KARLOVARSKY_KRAJ: 'KARLOVARSKY_KRAJ',
  KRAJ_VYSOCINA: 'KRAJ_VYSOCINA',
  KRALOVEHRADECKY_KRAJ: 'KRALOVEHRADECKY_KRAJ',
  LIBERECKY_KRAJ: 'LIBERECKY_KRAJ',
  MORAVSKOSLEZSKY_KRAJ: 'MORAVSKOSLEZSKY_KRAJ',
  OLOMOUCKY_KRAJ: 'OLOMOUCKY_KRAJ',
  PARDUBICKY_KRAJ: 'PARDUBICKY_KRAJ',
  PLZENSKY_KRAJ: 'PLZENSKY_KRAJ',
  REDITELSTVI_SILNIC_A_DALNIC: 'REDITELSTVI_SILNIC_A_DALNIC',
  SPRAVA_ZELEZNIC: 'SPRAVA_ZELEZNIC',
  STREDOCESKY_KRAJ: 'STREDOCESKY_KRAJ',
  USTECKY_KRAJ: 'USTECKY_KRAJ',
  ZLINSKY_KRAJ: 'ZLINSKY_KRAJ',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SvuCrossNames = ValuesOf<typeof SvuCrossNames>;

export type SvuCrossNamesRequest = SvuCrossNames;
export type SvuCrossNamesResponse = SvuCrossNames;
